import type { Company, Hall } from "../types";
import { formatHallLabel } from "../utils/locationLabel";

/** Synthetic pin grid when a company has no saved mapPoint yet. */
export function withMapLayout(companies: Company[], halls: Hall[]): Company[] {
  if (!companies.length) return companies;

  const effectiveHalls =
    halls.length > 0
      ? halls
      : [...new Set(companies.map((c) => c.hall).filter(Boolean))].map((label, i) => ({
          id: `hall-synth-${i}`,
          eventId: companies[0]!.eventId,
          name: formatHallLabel(label),
          label,
          floor: 1,
        }));

  return companies.map((company) => {
    if (company.mapPoint.x > 0 && company.mapPoint.y > 0) return company;

    const hallIdx = Math.max(
      0,
      effectiveHalls.findIndex((h) => h.label === company.hall),
    );
    const sameHall = companies.filter((c) => c.hall === company.hall);
    const idxInHall = sameHall.findIndex((c) => c.id === company.id);
    const cols = Math.max(1, Math.ceil(Math.sqrt(sameHall.length)));
    const row = Math.floor(idxInHall / cols);
    const col = idxInHall % cols;
    const hallCount = effectiveHalls.length;

    const zoneLeft = hallCount === 1 ? 18 : hallIdx % 2 === 0 ? 14 : 54;
    const zoneTop = hallCount <= 2 ? 22 + hallIdx * 8 : 18 + Math.floor(hallIdx / 2) * 32;
    const x = zoneLeft + ((col + 1) / (cols + 1)) * 28;
    const y = zoneTop + ((row + 1) / (Math.ceil(sameHall.length / cols) + 1)) * 22;

    return {
      ...company,
      mapPoint: {
        x: Math.min(92, Math.max(8, x)),
        y: Math.min(88, Math.max(12, y)),
        hallId: effectiveHalls[hallIdx]?.id ?? "",
      },
    };
  });
}
